import { List, PlusCircle } from 'lucide-react'
import { useState } from 'react'
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs'
import EmployeeForm from '../../forms/employee-form'
import { DisplayEmployeeGym } from './panels/display-employee-gym'

interface IEmployeesPage {}

export default function EmployeesPage(props: IEmployeesPage) {
  console.log(props)

  const [tab, setTab] = useState('members')

  return (
    <div className="w-full">
      <main className="flex flex-col gap-6">
        <div className="w-full overflow-y-scrol flex justify-between">
          <Tabs defaultValue="members" className="w-[320px]" onValueChange={setTab}>
            <TabsList>
              <TabsTrigger value="members" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <List className="text-sm" />
                Funcionarios
              </TabsTrigger>
              <TabsTrigger value="register-member" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <PlusCircle className="text-sm" />
                Cadastrar Funcionario
              </TabsTrigger>
            </TabsList>
          </Tabs>

          <div className="flex gap-2">
            {/* <Button className="text-acelerait-black flex gap-2 text-sm" variant="outline">
              <ListFilter />
              Filtro
            </Button> */}
          </div>
        </div>
        <div className="flex flex-col gap-4 border-acelerafit-gray-white rounded-md border p-6">
          {tab == 'members' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Funcionários</h3>
                <p className="text-sm text-acelerafit-gray-dark">Gerencie e acompanhe o cadastro, status e informações dos Funcionários.</p>
              </header>
              <div className="h-container-members overflow-hidden">
                <DisplayEmployeeGym />
              </div>
            </>
          )}

          {tab == 'register-member' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Adicionar funcionário</h3>
                <p className="text-sm text-acelerafit-gray-dark">Preencha as informações abaixo para registrar um novo funcionário no sistema.</p>
              </header>
              <EmployeeForm />
            </>
          )}
        </div>
      </main>
    </div>
  )
}
